import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import NotaryForm from './NotaryForm';

const NotaryActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const NotaryCreate = (props: any) => {
  return (
    <Create actions={<NotaryActions {...props} />} {...props}>
      <NotaryForm />
    </Create>
  );
};

export default NotaryCreate;
